import { render } from "./material-link-section.vue?vue&type=template&id=133c105c&ts=true"
import script from "./material-link-section.vue?vue&type=script&lang=ts"
export * from "./material-link-section.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__